import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateCustomBillomatArticlesConfigMutationVariables = Types.Exact<{
  update: Types.Scalars['String'];
}>;


export type UpdateCustomBillomatArticlesConfigMutation = { __typename?: 'Mutation', updateCustomBillomatArticlesConfig?: string | null };


export const UpdateCustomBillomatArticlesConfigDocument = gql`
    mutation updateCustomBillomatArticlesConfig($update: String!) {
  updateCustomBillomatArticlesConfig(update: $update)
}
    `;
export type UpdateCustomBillomatArticlesConfigMutationFn = Apollo.MutationFunction<UpdateCustomBillomatArticlesConfigMutation, UpdateCustomBillomatArticlesConfigMutationVariables>;

/**
 * __useUpdateCustomBillomatArticlesConfigMutation__
 *
 * To run a mutation, you first call `useUpdateCustomBillomatArticlesConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomBillomatArticlesConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomBillomatArticlesConfigMutation, { data, loading, error }] = useUpdateCustomBillomatArticlesConfigMutation({
 *   variables: {
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateCustomBillomatArticlesConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomBillomatArticlesConfigMutation, UpdateCustomBillomatArticlesConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomBillomatArticlesConfigMutation, UpdateCustomBillomatArticlesConfigMutationVariables>(UpdateCustomBillomatArticlesConfigDocument, options);
      }
export type UpdateCustomBillomatArticlesConfigMutationHookResult = ReturnType<typeof useUpdateCustomBillomatArticlesConfigMutation>;
export type UpdateCustomBillomatArticlesConfigMutationResult = Apollo.MutationResult<UpdateCustomBillomatArticlesConfigMutation>;
export type UpdateCustomBillomatArticlesConfigMutationOptions = Apollo.BaseMutationOptions<UpdateCustomBillomatArticlesConfigMutation, UpdateCustomBillomatArticlesConfigMutationVariables>;